import { sessionStorageKeys, STORAGE } from 'config/storage-config';
import { checkMatchPath } from 'utils/misc';
import { PARTNERS } from 'config/app-config';

export const getSessionStoragePartner = () =>
  STORAGE.getItem(sessionStorageKeys.PARTNER_PATH);

export const getJourneyName = () => {
  const partnerPath = getSessionStoragePartner();

  return Object.entries(PARTNERS).find(([, value]) =>
    checkMatchPath(partnerPath, value)
  )?.[0];
};
